<template>
  <div :id="id" :class="className" :style="{height:height,width:width}"/>
</template>

<script>
import echarts from 'echarts'
import resize from "@/components/Charts/mixins/resize";


export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    path: {
      type: String
    },
    params: {}
  },
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    this.initChart()
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  watch: {
    '$route': function (to, from) {
      if (to != from) {
        this.initChart();
      }
    }
  },
  methods: {
    initChart() {
      this.chart = echarts.init(document.getElementById(this.id), 'dark')
      // this.chart.showLoading({
      //   text: '加载中...'
      // })
      var post_params = Object.assign({}, {"extra_params": this.params});
      this.$http.post(process.env.VUE_APP_API_HOST + "/" + this.path, post_params, {"content-type": "application/json"}).then((res) => {
        // console.log(this.chart)
        // this.chart.hideLoading()
        this.chart.setOption({
          color: ["#5470c6", "#91cc75", "#fac858", "#ee6666", "#73c0de", "#3ba272", "#fc8452", "#9a60b4", "#ea7ccc"],
          backgroundColor: "#080A20",
          toolbox: {
            show: true,
            feature: {
              saveAsImage: {show: true},
              myTool1: {
                show: true,
                title: '全屏',
                icon: "path://M1.5 1a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-1 0v-4A1.5 1.5 0 0 1 1.5 0h4a.5.5 0 0 1 0 1h-4zM10 .5a.5.5 0 0 1 .5-.5h4A1.5 1.5 0 0 1 16 1.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 1-.5-.5zM.5 10a.5.5 0 0 1 .5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 0 14.5v-4a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v4a1.5 1.5 0 0 1-1.5 1.5h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 .5-.5z",
                onclick: () => {
                  const element = document.getElementById(this.id);
                  if (element.requestFullScreen) { // HTML W3C 提议
                    element.requestFullScreen();
                  } else if (element.msRequestFullscreen) { // IE11
                    element.msRequestFullScreen();
                  } else if (element.webkitRequestFullScreen) { // Webkit (works in Safari5.1 and Chrome 15)
                    element.webkitRequestFullScreen();
                  } else if (element.mozRequestFullScreen) { // Firefox (works in nightly)
                    element.mozRequestFullScreen();
                  }
                  // 退出全屏
                  if (element.requestFullScreen) {
                    document.exitFullscreen();
                  } else if (element.msRequestFullScreen) {
                    document.msExitFullscreen();
                  } else if (element.webkitRequestFullScreen) {
                    document.webkitCancelFullScreen();
                  } else if (element.mozRequestFullScreen) {
                    document.mozCancelFullScreen();
                  }
                },
              }
            }
          },
          label: {normal: {overflow: 'none'}},
          title: {
            text: res.data.title ? res.data.title : "",
            subtext: res.data.subtext ? res.data.subtext : "",
            left: res.data.title_postition ? res.data.title_postition : 'left',

          },
          series: [
            {
              name: res.data.name,
              type: 'gauge',
              min: 0,
              max: 100,
              data: res.data.data.sort(function (a, b) {
                return a.value - b.value;
              })

            }
          ]
        })
      })
    }
  }
}
</script>
